define('commons/monitoring/non-periodic-graph',['jquery', 'commons/monitoring/base-monitoring'], function($, BaseMonitoring) {
    /*************************************************************************************************************************************************
     * Non periodic graphs *
     ************************************************************************************************************************************************/

    var NonPeriodicGraph = function() {
        // Call parent init method
        BaseMonitoring.apply(this, arguments);
    };

    // Inherit from MessageMonitoring
    for ( var element in BaseMonitoring.prototype) {
        NonPeriodicGraph.prototype[element] = BaseMonitoring.prototype[element];
    }

    NonPeriodicGraph.prototype.processResponse = function(result) {
        var data = [];
        var labels = ["Time"];

        // Keys and labels of a given mapping key have the same length
        for (var i = 0; i < this.mapping.keys.length; i++) {
            labels.push(this.mapping.labels[i]);
        }

        for (var j = 0; j < result.data.length; j++) {
            var date = new Date();
            date.setTime(result.data[j].time);
            data.push($.merge([date], result.data[j].points));
        }

        var drawOptions = $.extend({
            stepPlot: true
        }, this.drawOptions);

        return {
            data: data,
            labels: labels,
            drawOptions: drawOptions
        };
    };

    NonPeriodicGraph.prototype.init = function() {
        // Init events
        this.button = this.container.find(".monitoring-submit");
        this.container.find(".date-picker").each($.proxy(function(index, node) {
            var $node = $(node);
            var datapickerOption = {
                altField: "#" + node.id + "-alt",
                altFormat: "yy-mm-dd" // ISO_8601
            }
            if (this.drawOptions.currentTime != undefined) {
                datapickerOption.maxDate = new Date(this.drawOptions.currentTime);
            }
            $node.datepicker(datapickerOption);
            if ($node.hasClass('from-time') && this.drawOptions.fromTime) {
                $node.datepicker("setDate", this.drawOptions.fromTime);
            }
            if ($node.hasClass('to-time') && this.drawOptions.toTime) {
                $node.datepicker("setDate", this.drawOptions.toTime);
            }
            $node.blur($.proxy(function() {
                if (this.val().length === 0) {
                    $('#' + this.attr('id') + '-alt').val("");
                }
            }, $node));
        }, this));
        this.button.click($.proxy(function() {
            var params = {};
            var fromTime = this.container.find('input.monitoring-from-time').val();
            if (fromTime) {
                params.fromTime = Date.UTC(parseInt(fromTime.substring(0, 4)), parseInt(fromTime.substring(5, 7)) - 1, parseInt(fromTime.substring(8,
                        10)), 0, 0, 0);
            }
            var toTime = this.container.find('input.monitoring-to-time').val();
            if (toTime) {
                params.toTime = Date.UTC(parseInt(toTime.substring(0, 4)), parseInt(toTime.substring(5, 7)) - 1, parseInt(toTime.substring(8, 10)),
                        0, 0, 0);
            }
            this.loadData(params);
        }, this));
    };

    NonPeriodicGraph.prototype.getURL = function() {
        return this.button.attr('data-url');
    };

    NonPeriodicGraph.prototype.refresh = function() {
        this.button.click();
    };

    return NonPeriodicGraph;
});
